export { default } from './IssueTableRow';
